export default "__VITE_ASSET__BqWtQl7c__"